import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { StepsSection } from './components/StepsSection';
import { SplitSection } from './components/SplitSection';
import { DifferenceSection } from './components/DifferenceSection';
import { WaitlistSection } from './components/WaitlistSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#f8f5ff] text-gray-900 font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StepsSection data-id="element-4" />
        <SplitSection data-id="element-5" />
        <DifferenceSection data-id="element-6" />
        <WaitlistSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}